import { TranslateService } from '@ngx-translate/core';

import { AppConstants } from '@shared/constants/app.consts';
import { TranslationDictionary } from '@shared/models';

import { capitalizeFirstLetter } from './data.utils';

export function getTranslationDictionaryCulture(
  value: TranslationDictionary,
  currentLang: string,
  languages: string[] = []
): string | undefined {
  return [currentLang, AppConstants.DefaultLanguage, ...languages, ...Object.keys(value)].find(
    (culture) => !!value[culture]
  );
}

export function getTranslationDictionaryValue(
  value: TranslationDictionary | undefined,
  currentLang: string,
  languages: string[] = []
): string {
  if (!value) {
    return '';
  }

  const culture = getTranslationDictionaryCulture(value, currentLang, languages);
  return culture ? value[culture] : '';
}

export function getEnumTranslationKey(value: string, ...args: string[]): string {
  let translationKeyPrefix = args.map(capitalizeFirstLetter).join('.') + '.';

  if (!translationKeyPrefix.includes('enum.')) {
    translationKeyPrefix = 'enum.' + translationKeyPrefix;
  }

  return translationKeyPrefix + capitalizeFirstLetter(value);
}

export function getEnumTranslation(
  translate: TranslateService,
  enumType: Record<string, string | number>,
  value: string | number
): string {
  const enumValueName = getEnumValueName(enumType, value);
  return translate.instant(getEnumTranslationKey(enumValueName));
}

function getEnumValueName(enumType: Record<string, string | number>, value: string | number): string {
  const directName = enumType[value];

  if (typeof directName === 'string') {
    return directName;
  }

  return (
    Object.entries(enumType).find(([key, enumValue]) => Number.isNaN(Number(key)) && enumValue === value)?.[0] ??
    String(value)
  );
}
